import { render, staticRenderFns } from "./ElProductCover.vue?vue&type=template&id=28150b36"
import script from "./ElProductCover.vue?vue&type=script&lang=js"
export * from "./ElProductCover.vue?vue&type=script&lang=js"
import style0 from "./ElProductCover.vue?vue&type=style&index=0&id=28150b36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports